"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rechargesTableConf = void 0;
var end2end_1 = require("@hudled/end2end");
var FooterCounterWithWord_1 = __importDefault(require("containers/TableMaker/components/FooterCounterWithWord"));
var constants_1 = require("containers/TableMaker/constants");
var BillingPeriod_1 = __importDefault(require("./CellComponents/BillingPeriod"));
var ExcludeCharge_1 = __importDefault(require("./CellComponents/ExcludeCharge"));
var ExcludeOrg_1 = __importDefault(require("./CellComponents/ExcludeOrg"));
var Organization_1 = __importDefault(require("./CellComponents/Organization"));
var RechargerStatus_1 = __importDefault(require("./CellComponents/RechargerStatus"));
var Source_1 = __importDefault(require("./CellComponents/Source"));
var Vendor_1 = __importDefault(require("./CellComponents/Vendor"));
var // XL, LG, MD, SM, XS,
XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, XS = constants_1.CellSize.XS, XSM = constants_1.CellSize.XSM;
exports.rechargesTableConf = {
    headersMap: {
        rechargerStatus: 'Status',
        'rechargedOrganization.name': 'Organisation/Company',
        payDate: 'Date',
        discountPercent: 'Discount',
        details: 'Details/Description',
        startDate: 'Billing Start',
        endDate: 'End',
        rechVendorId: 'Vendor',
        sourceInvNumber: 'Source Invoice',
        listPriceInAccFirmCurrency: 'List Price',
        amountInAccFirmCurrency: 'Partner Price',
    },
    extractors: {
        endDate: function (item) { var _a; return (_a = item.endDate) === null || _a === void 0 ? void 0 : _a.toDate(); },
        startDate: function (item) { var _a; return (_a = item.startDate) === null || _a === void 0 ? void 0 : _a.toDate(); },
    },
    layout: { fixedColumns: 3 },
    row: { sizing: 'compact' },
    cells: [
        {
            key: 'excludeCharge', cell: { width: XSM, isActionCell: true }, renderComponent: ExcludeCharge_1.default,
        },
        {
            field: 'rechargerStatus',
            cell: { width: LG, skipMarkRemoved: true },
            renderComponent: RechargerStatus_1.default,
            footerAggregate: 'count',
            countInHeader: true,
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('Charge'),
        },
        {
            field: 'rechVendorId',
            cell: { width: LG, hasBorderRight: true },
            footerAggregate: 'countUniq',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('Vendor'),
            renderComponent: Vendor_1.default,
        },
        {
            key: 'excludeOrgVendor', cell: { width: XS + 10 }, renderComponent: ExcludeOrg_1.default,
        },
        {
            field: 'rechargedOrganization.name',
            cell: { width: XL },
            footerAggregate: 'countUniq',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('Organisation'),
            renderComponent: Organization_1.default,
        },
        { field: 'payDate', cell: { width: MD }, renderField: function (v) { return v ? (0, end2end_1.getDateNice)(new Date(v)) : ''; } },
        {
            field: 'sourceInvNumber',
            cell: { width: LG },
            footerAggregate: 'countUniq',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('Source'),
            renderComponent: Source_1.default,
            truncate: {},
        },
        {
            field: 'plan',
            cell: { width: XL },
            footerAggregate: 'countUniq',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('Plan'),
            truncate: {},
        },
        { field: 'details', cell: { width: LG }, fallback: '-', truncate: {} },
        {
            fields: ['startDate', 'endDate'],
            cell: { width: LG, textAlign: 'right' },
            glueString: '-',
            renderComponent: BillingPeriod_1.default,
            defaultOrder: -1,
        },
        {
            field: 'listPriceInAccFirmCurrency', cell: { width: MD }, fallback: '-', footerAggregate: 'sum', money: {},
        },
        {
            field: 'discount',
            cell: { width: MD, textAlign: 'right' },
            footerAggregate: 'min-max',
            renderField: function (v) { return v ? "".concat((0, end2end_1.toFixedDigits)(1, 1)(v), "%") : '-'; },
        },
        {
            field: 'amountInAccFirmCurrency', cell: { width: MD }, fallback: '-', footerAggregate: 'sum', money: {},
        },
        // {
        //   field: 'clientPrice', cell: { width: MD }, fallback: '-', footerAggregate: 'sum', money: {},
        // },
    ],
};
